define('ordersDetailSupplierView',[
  'app',
  'module',
  'underscore',
  'backbone',
  'marionette',
  'buttonView',
  'ordersDetailSupplierInvoiceView',
  'ordersDetailSupplierProductView',
  'ordersDetailSupplierEditView',
  'portalConversationView',
  'template!ordersDetailSupplierView',
  'entities/suppliers/portal_orders'
], function (
  App,
  module,
  _,
  Backbone,
  Marionette,
  ButtonView,
  InvoiceView,
  ProductView,
  EditView,
  PortalConversationView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    className: 'orders-detail-supplier-view',
    template: Tpl,

    ui: {
      bodyContent: '.body-content',
      empty: '.empty',
      loader: '.loader-ctn'
    },

    regions: {
      invoiceRegion: '.invoice-region',
      productRegion: '.product-region',
      portalMessagesRegion: '.portal-messages-region',
      editButtonRegion: '.edit-button-region'
    },

    onRender: function () {
      this.editButtonView = new ButtonView({
        type: 'edit',
        color: 'orange',
        text: _.i18n('order.detail.supplier.send-order'),
        title: _.i18n('order.detail.supplier.send-order'),
        enabled: false
      });
      this.getRegion('editButtonRegion').show(this.editButtonView);
      this.editButtonView.on('click', _.bind(this.onEdit, this));

      //-------------------
      this.fetch();
    },

    fetch: function() {
      App.request('order-documents-supplier:list', this.model.get('order').get('purchaseOrderId')).done(_.bind(function (documents) {
        this.documents = documents;
        this.renderContent();
      }, this));
    },

    renderContent: function() {
      if(this.documents) {
        this.invoiceView = new InvoiceView({
          order: this.model.get('order'),
          model: new Backbone.Model(this.documents)
        });
        this.getRegion('invoiceRegion').show(this.invoiceView);

        /*this.productView = new ProductView({
          order: this.model,
          model: new Backbone.Model(this.documents)
        });
        this.getRegion('productRegion').show(this.productView);*/

        this.showPortalMessages();

        this.ui.bodyContent.css('display', 'flex');
        this.ui.empty.hide();
        this.ui.loader.hide();

        // Placing an order twice against a supplier's API would create two
        // orders, so the button closes once the order is out. A supplier portal
        // order can be pushed again — the portal updates the supplier's copy in
        // place — which is how an operator gets a corrected artwork across.
        this.editButtonView.enabled(this.documents.canResend === true);
      } else {
        this.ui.empty.css('display', 'flex');
        this.ui.loader.hide();
        this.editButtonView.enabled(true);
      }
    },

    /**
     * What the supplier and the support team have said about this order, when
     * it went out through the supplier portal.
     *
     * Asked of the portal rather than deduced from the documents: an order sent
     * to a supplier's own API has no portal order behind it, the lookup says
     * "not found", and the region simply stays empty.
     */
    showPortalMessages: function () {
      App.request('portal-orders:by-poi', this.model.get('order').get('purchaseOrderId'))
        .done(_.bind(function (portalOrder) {
          if (this.isDestroyed || !portalOrder) {
            return;
          }
          this.getRegion('portalMessagesRegion').show(
            new PortalConversationView({order: portalOrder, inline: true}));
        }, this));
    },

    onEdit: function () {
      EditView.prototype.open({
        model: this.model.get('order'),
        title: _.i18n('order.detail.supplier.send-order') + ' | ' + this.model.get('order').get('purchaseOrderId'),
        onConfirm: _.bind(function () {
          if(!this.isDestroyed)
            this.fetch();
        }, this)
      });
    }
  });
});
